import SideBg from './SideBg';

export default SideBg;
